import React, { useContext, useState, useEffect } from 'react';
import Input from '../../../molecules/formComponents/input/Input';
import FilledButton from '../../../molecules/buttons/filledButton/FilledButton';
import UnfilledButton from '../../../molecules/buttons/unfilledButton/UnfilledButton';
import Textarea from '../../../molecules/formComponents/textarea/Textarea';
import { useForm } from 'react-hook-form';
import { emailValidation, defaultValidation } from '../../../../utils/formValidation/FormValidation';
import { newActivityRequestApi } from '../../../../api/UtilsApi';
import AppContext from '../../../../context/AppContext';
import { normalizeString } from '../../../../utils/Utils';

function AddNewActivity({ activites = [] }) {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm();
  const { setModalVisible, createNotification } = useContext(AppContext);

  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [activitesDropdownVisible, setActivitesDropdownVisible] = useState(false);
  const [displayedActivites, setDisplayedActivites] = useState(activites || []);

  const watchNearActivity = watch('near_activity');

  useEffect(() => {
    if (!watchNearActivity) return setDisplayedActivites(activites || []);

    setDisplayedActivites(
      activites.filter(element =>
        normalizeString(element.description).toLowerCase().includes(normalizeString(watchNearActivity).toLowerCase()),
      ),
    );
  }, [activites, watchNearActivity]);

  function setChosenActivite(activite) {
    setValue('near_activity', activite.description);

    setTimeout(() => {
      setActivitesDropdownVisible(false);
    }, 200);
  }

  function closeDropdown() {
    setTimeout(() => {
      setActivitesDropdownVisible(false);
    }, 200);
  }

  async function onSubmit(values) {
    setIsButtonLoading(true);

    try {
      await newActivityRequestApi(values.email, values.naf, values.social_object, values.near_activity, values.content);
      createNotification(<>Votre demande d'ajout d'une nouvelle activité a bien été envoyée</>);
    } catch (error) {
      createNotification(
        <>Une erreur est survenue lors de l'envoi de votre demande d'ajout d'une nouvelle activité</>,
        'var(--red)',
        'var(--dark-blue)',
      );
    } finally {
      setModalVisible(false);
      setIsButtonLoading(false);
    }
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Input
        setValue={setValue}
        register={register}
        validation={emailValidation}
        error={errors?.email?.message}
        name='email'
        label='Adresse mail&nbsp;*'
      />
      <Input
        setValue={setValue}
        register={register}
        validation={defaultValidation}
        error={errors?.naf?.message}
        name='naf'
        label='Code NAF&nbsp;*'
      />
      <Input
        setValue={setValue}
        register={register}
        validation={defaultValidation}
        error={errors?.social_object?.message}
        name='social_object'
        label='Objet social (figurant sur le Kbis)&nbsp;*'
      />
      <Input
        setValue={setValue}
        placeholder='Cliquez et déroulez, ou cherchez par mot-clé...'
        label='Activité la plus proche (figurant dans notre liste)&nbsp;*'
        name='near_activity'
        register={register}
        validation={defaultValidation}
        error={errors?.near_activity?.message}
        icon='search'
        onFocus={() => setActivitesDropdownVisible(true)}
        onBlur={closeDropdown}
        preventAutoComplete
        bgColor='var(--main-color)'>
        <ul className={'activites-list' + (activitesDropdownVisible ? '' : ' h-none')}>
          {displayedActivites.map((activite, key) => (
            <li key={key} onClick={() => setChosenActivite(activite)}>
              {activite.description}
            </li>
          ))}
          {displayedActivites.length === 0 && <li className='activites-no-result'>Aucun résultat</li>}
        </ul>
      </Input>

      <Textarea
        register={register}
        validation={defaultValidation}
        error={errors?.content?.message}
        name='content'
        label='Commentaires'
        className=' small-textarea mb-sm'
      />
      <div className='form-legend mb-sm'>* Obligatoire</div>
      <div className='modal-buttons-row'>
        <UnfilledButton type='button' onClick={() => setModalVisible(false)}>
          Annuler
        </UnfilledButton>
        <FilledButton isLoading={isButtonLoading} type='submit' padding='10px 25px'>
          Valider
        </FilledButton>
      </div>
    </form>
  );
}

export default AddNewActivity;
